import React from "react";
import clsx from "clsx";

import { Typography, withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import styles from "./styles";

const YEARS_MAX = 7;

const getDisplayedValue = (digit) => {
  return digit + 1;
};

function RiskClassWidget({ classes, title, data }) {

  const isItemActive = (digit) => {
    return data === getDisplayedValue(digit);
  };

  const getYearsList = () => {
    return [...Array(YEARS_MAX).keys()];
  };

  const getLineClassName = (digit) => {
    return clsx([classes.item, isItemActive(digit) && classes.itemActive]);
  };

  const getLineComponent = (digit) => (
    <Grid item key={digit}>
      <div className={getLineClassName(digit)}>
        {getDisplayedValue(digit)}
      </div>
    </Grid>
  );

  return (
    <div className={classes.root}>
      <Typography variant="h2" classes={{ root: classes.headline }}>
        {title}
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs className={classes.legendItem}>Geringes Risiko<br />Geringer Ertrag</Grid>
        <Grid item xs={'auto'} className={classes.legendItem}>Hohes Risiko<br />Hoher Ertrag</Grid>
      </Grid>
      <Grid container spacing={1} className={classes.rating}>
        {getYearsList().map(getLineComponent)}
      </Grid>
    </div>
  );
}

export default withStyles(styles)(RiskClassWidget);
